module.exports = "../../app/cells/components/header/damasio_logos.erb";